export default {
  SET_APIS: 'SET_APIS',
  SET_CURRENT_API: 'SET_CURRENT_API',
  SET_LOADING: 'SET_LOADING',
};
